export type Company = 'qobee' | 'bridg' | 'nimbl' | 'tilroy' | 'contractify';

export const COMPANY_LOGOS: Record<Company, string | null> = {
  qobee: null,
  bridg: '/svg/logo-bridg.svg',
  nimbl: '/svg/logo-nimbl.svg',
  tilroy: '/svg/logo-tilroy.svg',
  contractify: '/svg/logo-contractify.svg',
} as const;

export const COMPANY_NAMES: Record<Company, string | null> = {
  qobee: 'Qobee',
  bridg: 'Bridg',
  nimbl: 'Nimbl',
  tilroy: 'Tilroy',
  contractify: 'Contractify',
} as const;

export function getCompanyLogo(companyName: string): string | null {
  const normalizedName = companyName.trim().toLowerCase() as Company;
  return COMPANY_LOGOS[normalizedName];
}

export function getCompanyName(companyName: string): string | null {
  const normalizedName = companyName.trim().toLowerCase() as Company;
  return COMPANY_NAMES[normalizedName];
}
